import type { ApiError } from '@openx/types/api.ts';
import upperFirst from 'lodash/upperFirst';

export const formatErrorMessage = (message: string) => {
  const normalizedMessage = upperFirst(message.trim());

  return /[.!?]$/.test(normalizedMessage) ? normalizedMessage : `${normalizedMessage}.`;
};

export function isApiError(item: unknown): item is ApiError {
  if (!item || typeof item !== 'object') {
    return false;
  }

  return !!(item as ApiError).http_status;
}
